import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getTopCities } from '../../../redux/states';
import CategoryStyles from '../../Category/Recommendations/styles.scss';
import CityVendorRecommendations from './CityVendorRecommendations';
import Styles from './styles.scss';

const TopCitiesRecommendations = ({ topCities }) =>
	topCities.map((city, index) => {
		const displayBorder = index !== topCities.length - 1;

		return (
			<div
				key={city}
				className={cx(
					CategoryStyles.container,
					displayBorder && Styles.bottomBorder,
				)}
			>
				<CityVendorRecommendations city={city} />
			</div>
		);
	});

TopCitiesRecommendations.propTypes = {
	topCities: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
	return {
		topCities: getTopCities(state),
	};
}

const enhance = compose(connect(mapStateToProps));

export default enhance(TopCitiesRecommendations);
